const EXAMPLE_CONTEXT_JSON = JSON.stringify(
  {
    type: "section",
    title: "Task audit context",
    blocks: [
      {
        type: "section",
        title: "Task overview",
        blocks: [
          {
            type: "fields",
            fields: [
              { label: "name", value: "Complete intro outcome" },
              { label: "status", value: "done" },
            ],
          },
        ],
      },
      {
        type: "section",
        title: "Agent decision",
        blocks: [
          {
            type: "fields",
            fields: [
              { label: "disposition", value: "done" },
              { label: "confidence", value: "high" },
            ],
          },
        ],
      },
    ],
  },
  null,
  2
);

const EXAMPLE_PERSONA_SUMMARY = `== ACE == GREEN (5/5)
  explanation: Workflow completed as expected.
  strengths: Correct tool use; outputs match catalogue definition.
== IVY == GREEN (5/5)
  explanation: No compliance concerns in this path.
== NOVA == AMBER (4/5)
  explanation: One redundant tool call before finish.`;

const EXAMPLE_VERDICT_ACE = JSON.stringify(
  {
    rating: "green",
    score: 5,
    explanation: "Task completed with correct outputs and disposition.",
    concerns: [],
  },
  null,
  2
);

const EXAMPLE_VERDICT_IVY = JSON.stringify(
  {
    rating: "green",
    score: 5,
    explanation: "No PII leakage or policy issues observed.",
    concerns: [],
  },
  null,
  2
);

/** Example placeholder values for Guardians v2 prompt templates. */
export const PROMPT_EXAMPLE_CONTEXT: Record<string, string> = {
  summary: "Complete intro outcome (done)",
  status: "done",
  context_json: EXAMPLE_CONTEXT_JSON,
  subject: "",
  ace_verdict: EXAMPLE_VERDICT_ACE,
  ivy_verdict: EXAMPLE_VERDICT_IVY,
  artifact_kind: "react_form",
  artifact_title: "Starter session outcome",
  tool_name: "write_artifact",
  step_index: "2",
  event_type: "fa_client.crm_data.plannr.custom.intro_session_date.changed",
  source: "plannr_sync",
  had_active_mission: "false",
  dispatch_health: "healthy",
  persona_summary: EXAMPLE_PERSONA_SUMMARY,
  entity_refs: JSON.stringify(
    {
      fa_client_id: "6a2bd051357fe9821a80d48e",
      plannr_account_uuid: "4fa8ae18-d71b-489c-88a3-2dd948f24d35",
    },
    null,
    2
  ),
};
